var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{attrs:{"id":"inspire"}},[_c('CMenu'),_c('CHeader'),(
      _vm.$vuetify.breakpoint.name == 'lg' ||
      _vm.$vuetify.breakpoint.name == 'xl' ||
      _vm.$vuetify.breakpoint.name == 'md'
    )?_c('v-main',{staticClass:"grey lighten-3 mt-5 px-10 pb-10"},[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1):_c('v-main',{staticClass:"grey lighten-3 mt-5 pb-10"},[_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('CFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }